/* eslint-disable no-nested-ternary */
/* global G */
import { isStr } from '@gaia/util'

/**
 * Returns whether the content of the clipboard is of type `type`.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @param {'text'|'data'} type        the type of content
 * @returns {(function(): Promise<*|boolean>)|*}
 */
const fn = (app, type) => async () => {
  const adapter = app[G.ADAPTER][G.CLIPBOARD]

  try {
    const content = type === 'text'
      ? await adapter[G.API].getText()
      : await adapter[G.API].getData()

    return content
      ? type === 'text'
        ? isStr(content)
        : !!content
      : false
  } catch (e) {
    console.error(e)
  }

  return false
}

export default fn
